module.exports = {
  "$id": "forgetPasswordInfoId",
  "type": "object",
  "properties": {
    "accountInput": {
      "title": "账号值",
      "type": "string"
    },
    "infoValue": {
      "title": "信息值",
      "type": "string",
      "pattern": "^[A-Za-z\\d]{4,50}$"
    }
  },
  "required": [
    "accountInput",
    "infoValue"
  ],
  "errorMessage": {
    "accountInput": {
      "message": "请输入正确的用户名/手机号/邮箱",
      "required": "请输入用户名/手机号/邮箱"
    },
    "infoValue": {
      "message": "仅支持输入英文及数字,长度4-50位！",
      "required": "请输入证件号"
    }
  }
}
